import $ from 'jquery';

export default class NavDesktop {
  constructor(el, postMessage) {
    this.$el = $(el);
    this.$overlay = $('.site-navigation-overlay');
    this.postMessage = postMessage;

    this.events = [
      // Open item on hover
      this.$el.on('mouseenter.navmenu', '.navmenu-item-parent:not([data-navmenu-ignore])', event => {
        this.openItem(event.currentTarget);
      }),

      // Close item on hover
      this.$el.on('mouseleave.navmenu', '.navmenu-item-parent:not([data-navmenu-ignore])', event => {
        this.closeItem(event.currentTarget);
      }),

      // Toggle item on touch
      this.$el.on('touchend.navmenu', '.navmenu-item-parent:not([data-navmenu-ignore]) > .navmenu-link-parent', event => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleItem(event.currentTarget.parentNode);
      }),

      // Keyboard navigation -- toggle submenus
      this.$el.on('focus.navmenu', '.navmenu-item-parent:not([data-navmenu-ignore]) > .navmenu-link-parent', event => {
        this.toggleItem(event.currentTarget.parentNode);
      }),

      // Keyboard navigation -- close submenus when moving to a new nav item
      this.$el.on('focus.navmenu', '.navmenu-depth-1 > .navmenu-item:not([data-navmenu-ignore]) .navmenu-link', event => {
        this.closeAll(event.currentTarget);
      }),

      this.$overlay.on('click.navmenu', event => {
        this.postMessage('nav:close-triggers', { source: el });
        this.closeAll();
        this.hideOverlay();
      }),
    ];
  }

  unload() {
    this.events.forEach($el => $el.off('.navmenu'));
  }

  showOverlay() {
    this.$overlay.show();
  }

  hideOverlay() {
    this.$overlay.hide();
  }

  openItem(el) {
    const $el = $(el);

    // Check if menu is already open
    const $menu = $el.children('.navmenu');
    if ($menu.revealer('isVisible')) return;

    $el.attr('aria-expanded', true);

    // Close previously opened items
    this.closeAll(el);
    this.postMessage('nav:close-triggers', { source: el });

    // Show menu
    $menu.revealer('show');

    // Adjust menu position if it runs off the screen
    $el.toggleClass('navmenu-adjust-right', (
      el.getBoundingClientRect().right + (el.clientWidth * 1.5) > window.innerWidth
    ));

    // Show overlay
    this.showOverlay();
  }

  closeAll(target) {
    this.$el.find('.navmenu-depth-1 > .navmenu-item-parent').each((i, el) => {

      // Close any submenus in this tree
      $(el)
        .find('.navmenu-item-parent')
        .each((i, submenu) => {
          if ($.contains(submenu, target)) return true;

          this.closeItem(submenu);
        });

      if ($.contains(el, target)) return true;

      // Close root-level menu item
      this.closeItem(el);
    });

    this.hideOverlay();
  }

  closeItem(el) {
    const $menu = $(el).children('.navmenu');
    if (!$menu.revealer('isVisible')) return;

    $(el).attr('aria-expanded', false);

    // Hide menu
    $menu.revealer('hide');

    // Hide overlay
    if (this.isFirstLevel(el)) {
      this.hideOverlay();
    }
  }

  toggleItem(el) {
    const $el = $(el);
    const $menu = $el.children('.navmenu');

    if ($menu.revealer('isVisible')) {
      this.closeItem(el);
    } else {
      this.openItem(el);
    }
  }

  isFirstLevel(el) {
    const $el = $(el);
    return (
      $el.is('.navmenu-item') && $el.parent().is('.navmenu-depth-1') ||
      $el.is('.navmenu-link') && $el.parent().parent().is('.navmenu-depth-1')
    );
  }

  isSingleLine() {
    const $menuItems = $('.navmenu-depth-1 > .navmenu-item', this.$el);
    let isSingleLine = true;
    let prevTop = Infinity;

    for (const menuItem of $menuItems) {
      const top = menuItem.getBoundingClientRect().top;

      if (prevTop == Infinity || prevTop == top) {
        prevTop = top;
      } else {
        isSingleLine = false;
        break;
      }
    }

    return isSingleLine;
  }
}
